import React, { useEffect, useState } from 'react'
import { Table, Row, Col, Typography } from 'antd';
import { loadingPlanService } from '../../../services';
import { useParams } from 'react-router-dom';
import { changeDocumentTitle } from '../../../utils/title';

const { Title } = Typography

function LoadingVehicleDetail() {

  const { id } = useParams();
  const [data, setData] = useState([])

  const columns = [
    {
      title: "Booking No",
      dataIndex: 'c_booking_number',
      key: 'c_booking_number',
    },
    {
      title: "Container No",
      dataIndex: 'c_container_number',
      key: 'c_container_number',
    },
    {
      title: "Container Size",
      dataIndex: 'container_size',
      key: 'container_size',
    },
    {
      title: "Destination",
      dataIndex: 'destination',
      key: 'destination',
    },
    {
      title: "Seal No",
      dataIndex: 'seal_number',
      key: 'seal_number',
    },
    {
      title: "Pull Out Date",
      dataIndex: 'pull_out_date',
      key: 'pull_out_date',
    },
  ];

  const initialize = async () => {
    const { success, data } = await loadingPlanService.fetchOffload(id)
    if (success) {
      setData(data)
    }
  }

  useEffect(() => {
    changeDocumentTitle("Container Vehicles");
     initialize()
  }, [])
  return (
    <>
      <div style={{ padding: '15px', border: '1px solid #ccc', borderRadius: '8px', backgroundColor: "#FFFFFF", marginTop: "20px" }}>
        <Row gutter={24}>
          <Col span={24}>
            <Title level={3}>OFF LOADED VEHICLES DETAILS</Title>
          </Col>
          <Col span={24}>
            <Table columns={columns} dataSource={data} scroll={{ x: "max-content" }} style={{ marginTop: '20px' }} pagination={false} />
          </Col>
        </Row>
      </div>
    </>
  )
}
export default LoadingVehicleDetail

